import { Component, Input } from '@angular/core';
import { GridDto } from '@hub/generated/models';
import { SelectItem } from 'primeng/api';
import { LookUps } from '@hub/common/LookUps';

@Component({
  selector: 'app-grid-settings-option',
  templateUrl: './grid-settings-option.component.html'
})
export class GridSettingsOptionComponent {
  constructor() {
    this.gridAreas = LookUps.getGridAreasLu();
   }

   gridAreas: SelectItem[] = [];

  @Input() GridData: GridDto;
}
